(() => {
  if (window.ysSequenceFilmstripsLoaded) return;
  window.ysSequenceFilmstripsLoaded = true;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new Map();
  const initialized = new WeakSet();
  let frame = 0;
  const clamp = (value, maximum) => Math.min(maximum, Math.max(0, value));
  const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  function update() {
    frame = 0;
    states.forEach((state, rail) => {
      if (!rail.isConnected) { states.delete(rail); return; }
      if (reducedMotion.matches || state.manual || !rail.getClientRects().length) return;
      const rect = rail.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      const progress = clamp((window.innerHeight * .85 - rect.top) / (window.innerHeight * .65), 1);
      rail.scrollLeft = progress * Math.max(0, rail.scrollWidth - rail.clientWidth);
    });
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  function init() {
    document.querySelectorAll('[data-ys-sequence-filmstrips]').forEach(root => {
      if (initialized.has(root)) return;
      initialized.add(root);
      const cards = [...root.querySelectorAll('[data-sequence-id]')];
      const search = root.querySelector('[data-ys-sequence-search]');
      const empty = root.querySelector('[data-ys-sequence-empty]');
      const status = root.querySelector('[data-ys-sequence-status]');
      search?.addEventListener('input', () => {
        const terms = normalize(search.value).split(/\s+/).filter(Boolean);
        let count = 0;
        cards.forEach(card => {
          const match = terms.every(term => normalize(card.dataset.sequenceSearch || card.textContent).includes(term));
          card.hidden = !match;
          if (match) count++;
        });
        if (empty) empty.hidden = count !== 0;
        if (status) status.textContent = `${count} ${count === 1 ? 'sequence' : 'sequences'} found`;
        schedule();
      });
      cards.forEach(card => card.addEventListener('toggle', () => {
        if (card.open) cards.forEach(other => { if (other !== card) other.open = false; });
        schedule();
      }));
    });
    document.querySelectorAll('[data-ys-sequence-rail]').forEach(rail => {
      if (states.has(rail)) return;
      const state = { manual: false };
      states.set(rail, state);
      const takeControl = () => { state.manual = true; };
      rail.addEventListener('pointerdown', takeControl, { passive: true });
      rail.addEventListener('touchstart', takeControl, { passive: true });
      rail.addEventListener('focus', takeControl);
      rail.addEventListener('wheel', event => { if (Math.abs(event.deltaX) > 0 || event.shiftKey) takeControl(); }, { passive: true });
      rail.addEventListener('keydown', event => {
        const maximum = Math.max(0, rail.scrollWidth - rail.clientWidth);
        const step = (rail.firstElementChild?.getBoundingClientRect().width || rail.clientWidth / 3) + 5;
        let position;
        if (event.key === 'ArrowRight') position = rail.scrollLeft + step;
        else if (event.key === 'ArrowLeft') position = rail.scrollLeft - step;
        else if (event.key === 'Home') position = 0;
        else if (event.key === 'End') position = maximum;
        else return;
        event.preventDefault(); takeControl(); rail.scrollLeft = clamp(position, maximum);
      });
    });
    schedule();
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  reducedMotion.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
